import './css/Card.scss';

const Card = ({ children, className, style }) => {
  return (
    <div className={`cardA ${className}`} style={style}>
      {children}
    </div>
  );
};

export default Card;
